import React from "react";
import { Button, Modal, Typography, Box } from "@mui/material";

const TiersSubmitModal = ({ open, handleClose, checkerData }) => {
    console.log("Checker Data", checkerData);
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            BackdropProps={{
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <Box className="modal-container" style={{ height: 'auto', width: '348px' }}>
                <Typography variant="h1" style={{ fontSize: '16px', fontWeight: '800', color:'#CF2030', marginBottom:'12px' }}>
                  TIEBREAKER ALERT
                </Typography>

                <Typography variant="p" style={{ fontSize: '16px', fontWeight: '400', color: '#002129', lineHeight:'1.2', marginBottom:'16px' }}>
                  Pool ties will be broken by better performance in our Sunday at Oakmont Prop Pool.
                </Typography>

                <img style={{marginBottom:'16px'}} src="https://poolpartyfilestorage.blob.core.windows.net/media/TheMajorsTour_SundayOakmontLogo.png" alt="US Open Props will be released Saturday Night"/>

                <Typography variant="p" style={{ fontSize: '16px', fontWeight: '400', color: '#002129', lineHeight:'1.2', marginBottom:'16px' }}>
                  Prop questions will be available Saturday evening, but you can secure your spot in the pool now.
                </Typography>

                <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap:'10px' }}>
                  <Box style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                      <Button sx={{ width: '115px', backgroundColor: 'transparent', boxShadow: '0 0 0', color: '#ababab'}} variant="contained" onClick={() => {handleClose(); window.location.href=window.location.href}}>Not Yet</Button>
                  </Box>

                  <Box style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                      <Button sx={{ width: '115px'}} variant="contained" onClick={() => window.location.href='https://poolpartygaming.com/quick-pick?mId=627a3bb7-e197-4bf0-9d1c-be2a5fcdbc8f&gId=5d130911-aed3-4e6c-8b93-e7b624dee29c&page=home'}>Join Pool</Button>
                  </Box>
                </Box>

            </Box>
        </Modal>
    );
}

export default TiersSubmitModal;